//@flow

import type {ProductPrices, ProductPricesWrapper, ProductPackPrices} from "./productPricingTypes";

const storeIndividualProductPrices = (win: WindowProxy, productPrices : ProductPricesWrapper) => {
  const productTiles = win.document.querySelectorAll(`.product-tile[data-product-code="${productPrices.productCode}"]`);

  if(productTiles === null || productTiles === undefined) return;

  productTiles.forEach((productTile) => {
    const customerPrices: ?ProductPrices = productPrices.customerPrices;
    if (customerPrices) {
      const customerPack1Prices: ?ProductPackPrices = customerPrices.PACK1;
      if (customerPack1Prices && (customerPack1Prices.gstInclusive >= 0) && (customerPack1Prices.gstExclusive >= 0)) {
        productTile.setAttribute("data-pack1-myprice-inc-gst", customerPack1Prices.gstInclusive.toString());
        productTile.setAttribute("data-pack1-myprice-exc-gst", customerPack1Prices.gstExclusive.toString());
      }

      const customerPack2Prices: ?ProductPackPrices = customerPrices.PACK2;
      if (customerPack2Prices && (customerPack2Prices.gstInclusive >= 0) && (customerPack2Prices.gstExclusive >= 0)) {
        productTile.setAttribute("data-pack2-myprice-inc-gst", customerPack2Prices.gstInclusive.toString());
        productTile.setAttribute("data-pack2-myprice-exc-gst", customerPack2Prices.gstExclusive.toString());
      }
    }

    const cmpPack1Prices: ?ProductPackPrices = productPrices.cmp.PACK1;
    if (cmpPack1Prices && (cmpPack1Prices.gstInclusive >= 0) && (cmpPack1Prices.gstExclusive >= 0)) {
      productTile.setAttribute("data-pack1-cmp-inc-gst", cmpPack1Prices.gstInclusive.toString());
      productTile.setAttribute("data-pack1-cmp-exc-gst", cmpPack1Prices.gstExclusive.toString());
    }

    const cmpPack2Prices: ?ProductPackPrices = productPrices.cmp.PACK2;
    if (cmpPack2Prices && (cmpPack2Prices.gstInclusive >= 0) && (cmpPack2Prices.gstExclusive >= 0)) {
      productTile.setAttribute("data-pack2-cmp-inc-gst", cmpPack2Prices.gstInclusive.toString());
      productTile.setAttribute("data-pack2-cmp-exc-gst", cmpPack2Prices.gstExclusive.toString());
    }
  });
}

const storeProductPrices = (win: WindowProxy, allPrices : ProductPricesWrapper[]) => {
  if(allPrices) {
    allPrices.forEach(productPrices => storeIndividualProductPrices(win, productPrices));
  }
};

export default storeProductPrices;


// WEBPACK FOOTER //
// ./javascript/product-search-page/product-pricing/storeProductPrices.js